<template>
  <span class="ui-cell-inline">
    <template v-for="direction in visibleDirections">
      <app-status-badge :key="`${direction}-badge`" design="new" compact :label="direction === 'arrival' ? 'Arrival' : 'Departure'" :tone="direction === 'arrival' ? 'green' : 'blue'" />
      <AppTableText :key="`${direction}-primary`" :text="primaryValue(direction)" />
      <AppTableText :key="`${direction}-secondary`" :text="secondaryValue(direction)" />
    </template>
    <AppTableText v-if="!visibleDirections.length" text="No client flight data" />
  </span>
</template>
<script>
import { format, isValid, parseISO } from 'date-fns'
import AppTableText from '@/components/AppTableText.vue'

export default {
  name: 'FlightTicketDetailsSummary',
  components: { AppTableText },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    visibleDirections() {
      return ['arrival', 'departure'].filter(direction => {
        const state = this.item[`${direction}_ticket_state`]
        const data = this.item[direction]
        return state?.is_uploaded || this.hasFlightData(data)
      })
    },
  },
  methods: {
    hasFlightData(data) {
      if (!data) return false
      return Boolean(data.flight_number || data.date || data.time || data.location)
    },
    primaryValue(direction) {
      const data = this.item[direction] || {}
      return data.flight_number || 'Flight number not set'
    },
    secondaryValue(direction) {
      const data = this.item[direction] || {}
      const dateTime = [this.formatDate(data.date), this.formatTime(data.time)].filter(Boolean).join(', ')
      const location = data.location?.short_name || data.location?.name
      return [dateTime, location].filter(Boolean).join(' · ') || 'Client details not set'
    },
    formatDate(value) {
      if (!value) return null
      const date = parseISO(value)
      return isValid(date) ? format(date, 'dd MMM yyyy') : value
    },
    formatTime(value) {
      return value ? String(value).slice(0, 5) : null
    },
  },
}
</script>

